import { Routes, Route } from 'react-router-dom';
import SubscribersPage from './components/SubscribersPage';
import UserDashboard from './components/UserDashboard';
import ProtectedRoute from './components/common/ProtectedRoute';
import './styles/custom.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<SubscribersPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;